// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nyxC","input":"styles_input__1zGxS"};